export enum BilingualFallbackType {
  BILINGUAL = 'BILINGUAL',
  NATIVE = 'NATIVE',
}
